<template>
    <section>
      <div v-if="getRole !== 'Analytics'" class="container.is-widescreen" style="padding-top:18px">

            <h1 class="title" style="color:#3e8ed0">Send single SMS</h1>
            <h4 class="subtitle">Send a message to a user.</h4>

                    <div class="container">
                        <div class="row" style="padding-bottom: 20px;">
    <div class="col">
        <b-field label="Project:">
          <b-select v-model="projectId" expanded>
              <option v-for="(value, key) in allProjects" :key="key" :value="value._id">
                {{ value.name }}
              </option>
            </b-select>


          <p v-if="selectedProject && selectedProject.allowCyrillic === false" style="color: #d9534f; font-size: 12px;">
                Cyrillic/Unicode/non-GSM messages are not allowed for this project.
          </p>



        </b-field>
    </div>
    <div class="col">
        <b-field label="Receiver:">
          <b-input v-model="receiver" placeholder="Example: '3897xxxxxxx'"></b-input>
        </b-field>
    </div>
  </div>

  <div style="text-align: center;">

        <b-field label="Message text:">
            
        <b-input v-model="messageText" type="textarea" 
        :maxlength="maxLength"
        :has-counter="false">
        </b-input>
        </b-field>

        <div style="text-align: right; font-size: 12px; color: #666; margin-top: -10px;">
          {{ count || 0 }} / {{ maxLength }}
        </div>


</div>

<div style="text-align: center; padding-bottom: 10px; color: red">
<p><b>{{ countString }} {{ noMessagesString }}</b></p>
</div>
  
  <div style="text-align: center;">
  <b-button type="is-primary" @click="addMess">Submit</b-button>
</div>
</div>
</div>
    </section>
  </template>
  
<script>
import { mapActions, mapGetters } from 'vuex'
import {
  analyzeSmsText,
  containsCyrillic as textContainsCyrillic,
  getTextareaMaxLength,
  trimTextToA1Limit
} from '@/utils/smsCounter'

export default {
  name: 'SendMessage',
  computed: {
    ...mapGetters(['allProjects', 'getRole', 'getWorkspaceId', 'getSessionId']),
    selectedProject () {
      return this.allProjects.find(project => project._id === this.projectId) || null
    }
  },
  created: function () {
    if (this.getRole === 'Super Admin') {
      this.fetchSendProjects()
    } else if (this.getRole !== 'Analytics') {
      this.fetchSendProjectsByWorkspaceId(this.getWorkspaceId)
    }
  },
  mounted: function () {
    this.updateSession(this.getSessionId)
  },
  data () {
    return {
      messageText: '',
      receiver: null,
      projectId: null,
      count: null,
      noMessages: 0,
      noMessagesString: null,
      countString: null,
      maxLength: 612,
      digitsArray: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
    }
  },
  watch: {
  messageText (newValue, oldValue) {
    this.updateMessageCounter(oldValue || '')
  }
},
  methods: {
    ...mapActions(['fetchSendProjects', 'addSingleMessage', 'fetchSendProjectsByWorkspaceId', 'updateSession']),

    containsCyrillic (text) {
      return textContainsCyrillic(text)
    },

  updateMessageCounter (previousText = '') {
  if (!this.messageText) {
    this.count = null
    this.noMessages = 0
    this.countString = null
    this.noMessagesString = null
    this.maxLength = 612
    return
  }

  const trimmedText = trimTextToA1Limit(this.messageText, previousText)
  if (trimmedText !== this.messageText) {
    this.messageText = trimmedText
    return
  }

  const analysis = analyzeSmsText(this.messageText)

  this.count = analysis.unitCount
  this.noMessages = analysis.parts
  this.maxLength = getTextareaMaxLength(this.messageText)
  this.countString = this.count === 1
    ? '1 character,'
    : this.count + ' characters,'
  this.noMessagesString = this.noMessages === 1
    ? '1 message'
    : this.noMessages + ' messages'
},

    showCyrillicAlert () {
      this.$buefy.dialog.alert({
        title: 'Error',
        message: 'Cyrillic/Unicode/non-GSM characters are not allowed for this project',
        confirmText: 'Ok!',
        type: 'is-danger',
        hasIcon: true,
        icon: 'times-circle',
        iconPack: 'fa'
      })
    },

    async addMess () {
      if (this.receiver === null || this.receiver === '' || this.projectId === null || this.messageText === '') {
        this.$buefy.dialog.alert({
          title: 'Error',
          message: 'Please fill in all fields.',
          confirmText: 'Ok!',
          type: 'is-danger',
          hasIcon: true,
          icon: 'times-circle',
          iconPack: 'fa'
        })
      } else if (this.selectedProject && this.selectedProject.allowCyrillic === false && this.containsCyrillic(this.messageText)) {
        this.showCyrillicAlert()
      } else {
        const payload = {
          text: this.messageText,
          receiver: [this.receiver],
          projectId: this.projectId,
          size: this.noMessages
        }
        await this.addSingleMessage(payload)
        this.reset()
        this.updateSession(this.getSessionId)
      }
    },

    reset () {
      this.messageText = null
      this.receiver = null
      this.projectId = null
      this.count = null
      this.noMessages = 0
      this.countString = null
      this.noMessagesString = null
      this.maxLength = 612
    },

    isValidNumber (receiver) {
      if (receiver.length === 11 && receiver[0] === '3' && receiver[1] === '8' && receiver[2] === '9' && receiver[3] === '7') {
        let flag = true
        for (let i = 4; i < 11; i++) {
          if (!this.digitsArray.includes(receiver[i])) {
            flag = false
          }
        }
        return flag
      } else {
        return false
      }
    }
  }
}
</script>

<style>
</style>